import { render, staticRenderFns } from "./navTabs.vue?vue&type=template&id=a010b892&scoped=true"
import script from "./navTabs.vue?vue&type=script&lang=js"
export * from "./navTabs.vue?vue&type=script&lang=js"
import style0 from "./navTabs.vue?vue&type=style&index=0&id=a010b892&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a010b892",
  null
  
)

export default component.exports